<span *ngIf="voce.cdElemento == 'COLONNA'">{{voce.titolo}}</span>
<span *ngIf="voce.cdElemento == 'ETICHETTA'">{{voce.titolo}}</span>
<a *ngIf="voce.cdElemento == 'LINK' && voce.flgEsterno" href="{{voce.url}}" rel="{{voce.noFollow ? 'noFollow' : ''}}" target="_blank">{{voce.titolo}}</a>
<a *ngIf="voce.cdElemento == 'LINK' && !voce.flgEsterno" [appHref]="voce.url">{{voce.titolo}}</a>
<a *ngIf="voce.cdElemento == 'PAGINA' && !voce.flgEsterno" [appHref]="'/informazioni/' + voce.seo?.slug">{{voce.titolo}}</a>
<a *ngIf="voce.cdElemento == 'PAGINA_TEMATICA' && !voce.flgEsterno" [appHref]="'/esplora/' + voce.seo?.slug">{{voce.titolo}}</a>

